// create canned job
export const CREATE_CANNED_JOBS_REQUEST = 'CREATE_CANNED_JOBS_REQUEST';
export const CREATE_CANNED_JOBS_SUCCESS = 'CREATE_CANNED_JOBS_SUCCESS';
export const CREATE_CANNED_JOBS_FAIL = 'CREATE_CANNED_JOBS_FAIL';

// update canned job
export const UPDATE_CANNED_JOBS_REQUEST = 'UPDATE_CANNED_JOBS_REQUEST';
export const UPDATE_CANNED_JOBS_SUCCESS = 'UPDATE_CANNED_JOBS_SUCCESS';
export const UPDATE_CANNED_JOBS_FAIL = 'UPDATE_CANNED_JOBS_FAIL';

// delete canned job
export const DELETE_CANNED_JOBS_REQUEST = 'DELETE_CANNED_JOBS_REQUEST';
export const DELETE_CANNED_JOBS_SUCCESS = 'DELETE_CANNED_JOBS_SUCCESS';
export const DELETE_CANNED_JOBS_FAIL = 'DELETE_CANNED_JOBS_FAIL';

// clear state
export const CLEAR_CANNED_JOB_STATE = 'CLEAR_CANNED_JOB_STATE';
